import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    TGridSchema,
    useAuth,
    useFetch,
    useForm,
    useGrid,
    useModal,
    usePage,
    useResource,
    useStore,
    useToast,
} from "@/comn/hooks";
import { APIS, SF_IQS_SRCH, SG_IQS, URLS } from "@/tra/tancis/ptli/mypage/myiqs/services/ptliMypageIqsService";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*
 * Role Management List
 * !== 역할 관리 목록 ==!
 */
export const PTLI03040001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0019"],
    });
    const modal = useModal();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [docCdVal, setDocCdVal] = useState();
    const [mode, setMode] = useState("view");

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "CLR0058" }],
    });

    const form = {
        iqsSrch: useForm({
            defaultSchema: SF_IQS_SRCH,
            defaultValues:
                {
                    ...pgeStore?.form,
                    regstSrchStrtDt: comnUtils.getDate({ m: -1 }),
                    regstSrchEndDt: comnUtils.getDate(),
                } || {},
        }),
    };

    const grid = {
        iqs: useGrid({
            defaultSchema: SG_IQS,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getDocOptList: useFetch({
            api: () => APIS.getDocOptList(),
            enabled: comnUtils.isEmpty(form.iqsSrch.errors),
            key: [grid.iqs.page, grid.iqs.size],
            onSuccess: (data) => {
                const optList = data.optList.content;
                const filteredOptList = optList.filter((item: any) => item.docCdValNm);
                const selectOptArr = filteredOptList.map((item: any) => ({
                    label: item.docCdValNm,
                    value: item.docCdVal,
                }));
                form.iqsSrch.setSchema("docCdVal", { options: selectOptArr });
                fetch.getIQSList.fetch();
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.com.00025" }); // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
        // get List Of Bulletin board Message !== 게시글 목록 조회==!
        getIQSList: useFetch({
            api: (page = grid.iqs.page) =>
                APIS.getIQSList({ ...form.iqsSrch.getValues(), loginUsrId: auth.get("usrId") }, page, grid.iqs.size),
            enabled: comnUtils.isEmpty(form.iqsSrch.errors) && form.iqsSrch.isSubmitted,
            key: [grid.iqs.page, grid.iqs.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.iqsSrch.getValues(),
                    page: grid.iqs.page,
                    size: grid.iqs.size,
                });
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.com.00025" }); // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
        // get List Of Bulletin board Message !== 게시글 목록 조회==!
        modifyIqstrgtDispYn: useFetch({
            api: (data: any) =>
                APIS.modifyIqstrgtDispYn(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        handler.onSrchBtnClick();
                    },
                });
            },
            onError: () => {},
        }),
    };
    const handler = {
        onSrchBtnClick: () => {
            grid.iqs.setPage(0);
            fetch.getDocOptList.fetch();
        },
        onDocCdValChange: (props: any) => {
            setDocCdVal(props);
            form.iqsSrch.setValue("actor", null);
            form.iqsSrch.setValue("cmntRegstId", null);
        },
        onEditModeClick : () =>{
            setMode("edit");
        },
        modifyIqstrgtDispYn : () =>{
            let selectedIQSList = grid.iqs.getChecked();
            const trgtDispYn = form.iqsSrch.getValue("trgtDispYn") === "Y" ? "N" : "Y";
            selectedIQSList.map((obj) => {
                obj.trgtDispYn = trgtDispYn;
            })
            fetch.modifyIqstrgtDispYn.fetch({iqsTrgtList : selectedIQSList});
        },
    };
    const render = {
        cell: {
            reffNo: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0304002s}/${rowValues.iqsUuid}?menuId=${menuId}`}>{value}</Link>;
            },
        },
    };

    useEffect(() => {
        if(!pgeStore?.form.trgtDispYn){
            form.iqsSrch.setValue("trgtDispYn","Y");
        }
        setDocCdVal(form.iqsSrch.getValue("docCdVal"));
        fetch.getIQSList.fetch();
    }, []);
    useEffect(() => {
        if(mode === "edit"){
            grid.iqs.setOption("checkbox", true);
        }
        if(mode === "view"){
            grid.iqs.setOption("checkbox", false);
        }
    }, [mode]);
    useEffect(() => {}, [docCdVal]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.iqsSrch.schema.reffNo} readOnly={mode==="edit"?true:false} />
                            <Group.Control
                                {...form.iqsSrch.schema.docCdVal}
                                onChange={(props) => {
                                    handler.onDocCdValChange(props);
                                }}
                                readOnly={mode==="edit"?true:false}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.iqsSrch.schema.srchFrstRegstId} disabled={mode==="edit"?true:false}/>
                            <Group.Control {...form.iqsSrch.schema.frstRgsrDtmRnge} disabled={mode==="edit"?true:false}/>
                        </Group.Row>
                        {docCdVal === "CUSDEC501" && (
                            <Group.Row>
                                <Group.Control {...form.iqsSrch.schema.actor}  readOnly={mode==="edit"?true:false}/>
                                <Group.Control {...form.iqsSrch.schema.cmntRegstId}  readOnly={mode==="edit"?true:false}/>
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.iqsSrch.schema.trgtDispYn} readOnly={mode==="edit"?true:false} onChange={handler.onSrchBtnClick}/>
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.iqsSrch.reset()} disabled={mode==="edit"?true:false} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} disabled={mode==="edit"?true:false} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.iqs.grid} data={fetch.getIQSList.data?.myIqsList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                {(mode === "view" && (
                    <Layout.Right>
                        <Button role={"edit"} onClick={handler.onEditModeClick}>{t("B_EDIT_LST")}</Button>
                    </Layout.Right>
                ))}
                {(mode === "edit" && (
                    <>
                        <Layout.Left>
                            <Button role={"list"} onClick={() => setMode("view")}>{t("B_PRE")}</Button>
                        </Layout.Left>
                        {( form.iqsSrch.getValue("trgtDispYn")==="Y" && (
                            <Layout.Right>
                                <Button role={"edit"} onClick={handler.modifyIqstrgtDispYn}>{t("B_HIDE")}</Button>
                            </Layout.Right>
                        ))}
                        {( form.iqsSrch.getValue("trgtDispYn")==="N" && (
                            <Layout.Right>
                                <Button role={"edit"} onClick={handler.modifyIqstrgtDispYn}>{t("B_CNCL_HIDE")}</Button>
                            </Layout.Right>
                        ))}
                    </>
                ))}
            </Layout>
        </Page>
    );
};
